import * as variants from "./variants";

export const schemas = variants;
